export default __webpack_public_path__ + "static/N0201-cb9ca4bd19f9cb6d69ea2384ecdb59f7.png";